import { render, staticRenderFns } from "./CarteraInsumos.vue?vue&type=template&id=48bb0ee5"
import script from "./CarteraInsumos.vue?vue&type=script&lang=js"
export * from "./CarteraInsumos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports